import React, { Component }      from 'react';
import {connect}                 from 'react-redux';
import { Modal}           from 'react-bootstrap';
import Dropzone                  from 'react-dropzone';
import {Field, reduxForm, reset} from 'redux-form';
import {SetLikePostUser,
        GetTipoMidiaPost,
        GetQtdCommentPost,
        GetRemoverPostEquipe,
        SendPublic,
        SetValidUrlYoutube,
        ClearUrl,
        GetRegistroPostEquipe}   from '../../../../actions/grupoAction';
import EquipeComentario          from './equipe_comentario';
import { SetError }              from '../../../../actions/notificacaoAction';
import FlashRetornoNulo          from '../../../../container/FlashRetornoNulo';
import RenderAvatarP             from '../../../../container/render_avatar_p'
import RenderAvatarM             from '../../../../container/render_avatar_m'
import BtAcaoComentario          from '../../../../container/btAcaoRemoverItem';
import BtLikeEquipe              from '../../../../container/bt_like_equipe';
import BtComentarioEquipe        from '../../../../container/bt_comentario_equipe';
import RenderFormTextVideo       from '../../../../container/renderFormTextVideo';
import RenderPrevImg             from '../../../../container/renderPrevImagemTimeLine'; 
import TimeLineItem              from '../../../../container/renderHudTimeLine';
import Foto                      from '../../../../img/comunication/avatar/christian.png';
import validate                  from '../../../../service/validate_nave';

const renderField = ({ input, label,length, type, placeholder,value,meta: { touched, error } }) => (

    <textarea 
            className="form-control" 
            rows="2"
            placeholder={placeholder} 
            {...input}></textarea>
)

class Equipe_TimeLine extends Component {

    constructor(props){
        super(props);
        this.state = {
                        like             : "#AAB8BE",
                        ListItemPosts    : [],
                        ItemPostTimeline : [],
                        showModal        : false,
                        publicImg        : false,
                        publicMov        : false,
                        buttonDisabled   : false,
                        validMov         : false,
                        publicText       : "",
                        video            : "",
                        errors           : {},
                        use_id           : this.props.session.id,
                        per_id           : this.props.session.perfil,
                        equ_id           : this.props.equ_id,
                        post_tipo        : 1,
                        files            : null,
                        textButtonPublic : "Publicar"

                    }

        this.onChange      = this.onChange.bind(this);
        this.onChangeVideo = this.onChangeVideo.bind(this);
        this.PublicMovie   = this.PublicMovie.bind(this);
        this.onDrop        = this.onDrop.bind(this);

    
    }

    close() {
       this.setState({showModal: false});
    }
    
    open(val) {
       this.setState({showModal: true,ItemPostTimeline:this.props.all_equipe_posts[val]});
    }

    excluirPostGrupo(id){
        const acao  = window.confirm("Deseja Remover?");
        if (acao) {
            this.props.GetRemoverPostEquipe(this.props.session.id,id);
        }
    }   

    renderListItemPosts(){

         const retornoListaItem = this.props.all_equipe_posts;
       
         if(retornoListaItem){

                return retornoListaItem.map((elem,i)=>{
                    
                        //Componente gerador botao de like    
                        const btLike       = <BtLikeEquipe vetor={i} funcao={this.likePost.bind(this,elem.equ_pos_id)}/>;
                        //Componente gerador botao de comentario
                        const btComentario = <BtComentarioEquipe vetor={i} funcao={this.open.bind(this,i)}/>;
                      
                            return  <TimeLineItem
                                        key          = {i}
                                        id           = {elem.equ_pos_id}
                                        foto         = {elem.use_foto}
                                        nome         = {elem.use_nome}
                                        btAcao       = {elem.equ_pos_cod_usuario === this.props.session.id ? <BtAcaoComentario funcao={this.excluirPostGrupo.bind(this,elem.equ_pos_id,i)}/> : ""}
                                        dataCriado   = {elem.created_at}
                                        postConteudo = {elem.equ_pos_post}
                                        midia        = {elem.equ_pos_midia}
                                        tipo         = {elem.equ_pos_tipo}
                                        postMidia    = {<div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(elem)}} />}
                                        btLike       = { btLike }
                                        btComentario = { btComentario }
                                        /> 
                        });

         }else{
             return <li>
                    <div className="timeline">
                        <FlashRetornoNulo text="Seja o primeira a publicar na equipe."/>
                    </div>
                    </li> ;
         }
    }

    likePost(val){
     
        this.props.SetLikePostUser(val,this.props.session.id);
    }

    onDrop(files) {
      this.setState({selectedImg:files[0].preview,files:files,publicImg:true,publicMov:false,post_tipo:2});
    }
   
    removeImgSelect(){
      this.setState({selectedImg:[],publicImg:false,post_tipo:1, files: null})
    }
   
    removeMovSelect(){
      this.setState({publicMov:false,post_tipo:1,video: "",validMov:false})
    }
   
    PublicMovie(){
     this.setState({publicMov:true,publicImg:false});
    }
   
    onChange(e) {
     this.setState({publicText: e.target.value,errors:{}});
    }
   
    onChangeVideo(e) {
        const retValid =  this.props.SetValidUrlYoutube(e.target.value);
        this.setState({ 
                        video     : (retValid === 1 ? e.target.value:""),
                        validMov  : (retValid === 1 ? false:true),
                        post_tipo : (retValid === 1 ? 3:1)
                        });
    }
   
    statesComponente(){
        this.setState({ textButtonPublic:"Publicar",buttonDisabled:false,publicText:"",validMov:false});
    }
   
    handleSubmit(e){
            this.setState({ textButtonPublic:"Enviando...",buttonDisabled:true});
            const dados   = {
                                equ_pos_cod_equipe  : this.state.equ_id,
                                equ_pos_cod_usuario : this.state.use_id,
                                equ_pos_tipo        : this.state.post_tipo,
                                equ_pos_midia       : (this.state.post_tipo === 3 ? this.props.ClearUrl(e.video) : "" ),
                                equ_pos_post        : e.publicText
                            }
                       
            this.props.SendPublic(dados,this.state.files).then((response) =>{
                    this.statesComponente();
                    this.removeMovSelect();
                    this.removeImgSelect(); 
                }).catch((error)=>{
                    this.statesComponente();
                    this.props.SetError(500);
                });
    }

    render(){
 
        const {handleSubmit} = this.props;
        return (
            <div className="communication comunicarion-equipe">
                <div className="communication-info">
                    <div className="communication-info-item">{(!this.props.disciplina?"Carregando...":this.props.equipe.equ_nome)}</div>
                    <div className="communication-info-item">{(!this.props.disciplina?"Carregando...":this.props.disciplina.dis_nome)}</div>
                </div>
                <div className="communication-new">
                    <div className="author author-with-link author-with-line author-with-line-half author-with-line-marker">
                        {/* <div className="author-instance">
                            <RenderAvatarM Foto={Foto}/>
                        </div> */}
                        <div className="author-avatar">
                            <RenderAvatarP Foto={this.props.session.foto}/>     
                        </div>
                    </div>
                   <form className="communication-new-input communication-container-box communication-new-input-link" onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                        <div className="communication-container-box-left">
                            <Field name="publicText" type="textarea" component={renderField} label="" placeholder="Criar uma publicação"/> 
                        </div>
                        <div className="communication-container-box-right">
                            <div className="communication-container-box-info">{(!this.props.disciplina?"...":`TURMA ${this.props.disciplina.dis_id_totvs}`)}</div>
                            <div className="communication-container-box-actions">
                                <button type="submit" className="communication-container-box-action">
                                    <span>Enviar</span>
                                </button>
                                <div className="communication-container-box-tools">
                                  <Dropzone className="action action-icon action-simple" multiple={false} accept="image/png,image/jpeg" onDrop={this.onDrop.bind(this)}>
                                        <i className="gamefica-icon gamefica-photo"></i>
                                    </Dropzone>
                                    <a href={void(0)} className="action action-icon action-simple" onClick={this.PublicMovie}>
                                        <i className="gamefica-icon gamefica-video"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </form>                    
                </div>
                <div className="communication-messages hud-scroll-tip">
                   {this.state.publicImg ? <RenderPrevImg prevImg={this.state.selectedImg} funcao={this.removeImgSelect.bind(this)}/>:""} 
                   {this.state.publicMov ? <Field name="video" type="text" component={RenderFormTextVideo} placeholder="Criar uma publicação" funcao={this.removeMovSelect.bind(this)} onChange={this.onChangeVideo}/>:"" }
                   {this.renderListItemPosts()}
                </div>
                <Modal show={this.state.showModal}  bsSize="lg">
                   <EquipeComentario equ_id={this.state.equ_id} funcao={this.close.bind(this)} ItemPostTimeline={this.state.ItemPostTimeline}/> 
                </Modal>
            </div>
        );
    }
}
const afterSubmit = (result, dispatch) => dispatch(reset('post_equipe'));
function  mapStateToProps(state){
    return {
       session          : state.auth.session,
       equipe           : state.equipeReducer.nome_equipe,
       all_equipe_posts : state.equipeReducer.all_equipe_posts,
       disciplina       : state.equipeReducer.disciplina_equipe
    }
}


export default reduxForm({
    form                     : 'post_equipe', //                 <------ same form name
    destroyOnUnmount         : true, //        <------ preserve form data
    forceUnregisterOnUnmount : true, // <------ unregister fields on unmount
    onSubmitSuccess          : afterSubmit,
   validate
 })(connect(mapStateToProps,{SetLikePostUser,GetTipoMidiaPost,GetQtdCommentPost,GetRemoverPostEquipe,SendPublic,SetValidUrlYoutube,ClearUrl,SetError,GetRegistroPostEquipe})(Equipe_TimeLine));
 


// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/equipe/equipe_timeLine.js